;(function module() {
  angular.module('app.ui.form.ctrls').controller('ChangePasswordController', [
    'ForgetPasswordApi',
    'userService',
    'logger',
    'usSpinnerService',
    '$scope',
    function controller(
      ForgetPasswordApi,
      userService,
      logger,
      usSpinnerService,
      $scope
    ) {
      let vm = this
      vm.hideDropDown = () => {
        vm.showClass = ''
      }

      vm.showDropDown = () => {
        if (vm.showClass === '') {
          vm.showClass = 'show'
        } else {
          vm.showClass = ''
        }
      }

      vm.changePassword = async () => {
        try {
          const {status} = await ForgetPasswordApi.changePassword({
            email: vm.user.email,
          })
          vm.startSpin()
          if (status === 201) {
            vm.sentEmail = true
            const message = `Request sent. Please check your email inbox for
              instructions on how to change your LexStep password.`
            logger.notify('success', message)
            vm.stopSpin()

            $scope.$apply()
          }
        } catch (error) {
          vm.stopSpin()
          vm.notify('error', error.data.message)
        }
      }

      vm.startSpin = () => {
        usSpinnerService.spin('spinner-change-password')
      }

      vm.stopSpin = () => {
        usSpinnerService.stop('spinner-change-password')
      }

      vm.initializePage = async () => {
        vm.user = await userService.getUser()
      }

      vm.initializePage()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/change-password/change-password.ctrl.js